import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import '@mdi/font/css/materialdesignicons.css'
import DayJsAdapter from '@date-io/dayjs'
import dayjs from 'dayjs'
import updateLocale from 'dayjs/plugin/updateLocale'
import 'dayjs/locale/en'
import i18n from '@/services/languages/i18n'
import type { App } from 'vue'

const t = i18n.global.t
dayjs.extend(updateLocale)
dayjs.updateLocale('en', {
  monthsShort: [
    t('monthShort.jan'),
    t('monthShort.feb'),
    t('monthShort.mar'),
    t('monthShort.apr'),
    t('monthShort.may'),
    t('monthShort.jun'),
    t('monthShort.jul'),
    t('monthShort.aug'),
    t('monthShort.sep'),
    t('monthShort.oct'),
    t('monthShort.nov'),
    t('monthShort.dec'),
  ],
  months: [
    t('month.jan'),
    t('month.feb'),
    t('month.mar'),
    t('month.apr'),
    t('month.may'),
    t('month.jun'),
    t('month.jul'),
    t('month.aug'),
    t('month.sep'),
    t('month.oct'),
    t('month.nov'),
    t('month.dec'),
  ],
})

const themes = {
  light: {
    dark: true,
    colors: {
      danger: '#d12b28ff',
      'brand-green': '#BEF975',
      'brand-yellow': '#F7BF30',
    },
  },
}

const vuetify = createVuetify({
  icons: {
    defaultSet: 'mdi', // This is already the default value - only for display purposes
  },
  theme: {
    defaultTheme: 'light',
    themes,
  },
  date: {
    adapter: DayJsAdapter,
    locale: { code: 'en' },
    formats: {
      datePicker: 'dd MMMM yyyy', // format used in v-date-picker
      // Optional: other formats like input, display, etc.
      keyboardDate: 'dd MMMM yyyy', // for manual input fields
    },
  },
})

export default function (app: App) {
  app.use(vuetify)
}
